import {DetailsField} from '@/components/ui/details-atoms/DetailsAtoms'
import {useTranslation} from '@/translations/i18n'
import {Text} from '@/components/ui/text/Text'
import dayjs from 'dayjs'
import {StyledExpirationDateInfo, StyledPatientAbsenceProjectInfo} from './style'
import {formatLocaleDate} from '@/dayjs'
import {Badge} from '@/components/ui/badge/Badge'
import {projectStatusToBadgeVariant, projectStatusToLabel} from '@/features/projects/utils'
import {useMemo} from 'react'
import {InputHelpText} from '@/components/ui/input-help-text/InputHelpText'
import {Skeleton} from '@/components/ui/skeleton/Skeleton'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {useGetPatient} from '@/features/patients/services/useGetPatient'

interface AddPatientAbsencePriInfoFieldProps {
    patientId?: string
    patientName?: string
}

export const AddPatientAbsencePriInfoField = ({patientId, patientName}: AddPatientAbsencePriInfoFieldProps) => {
    const {t} = useTranslation()

    const {
        data: patient,
        isLoading,
        isError
    } = useGetPatient({
        patientId,
        responseType: 'extended',
        options: {enabled: !!patientId}
    })

    const project = useMemo(() => patient?.project, [patient])

    return (
        <DetailsField fullWidth>
            <Text size="textSm">{t('commons:pri')}</Text>
            <Flexbox fullWidth align="center" style={{height: '100%'}}>
                {patientId ? (
                    isLoading ? (
                        <Skeleton width={300} height={20} />
                    ) : isError ? (
                        <InputHelpText error={t('errors:default')} />
                    ) : !project ? (
                        <StyledPatientAbsenceProjectInfo align="end">
                            <Text palette="neutral" shade="500" size="textSm">
                                {t('agenda:no_project_found', {name: patientName})}
                            </Text>
                        </StyledPatientAbsenceProjectInfo>
                    ) : (
                        <StyledPatientAbsenceProjectInfo gap={1.5} fullWidth align="end">
                            <span>
                                <b>{project.code}</b>
                            </span>

                            {project.status && (
                                <Badge
                                    size="sm"
                                    shape="rectangle"
                                    variant={projectStatusToBadgeVariant[project.status]}
                                >
                                    {t(projectStatusToLabel[project.status])}
                                </Badge>
                            )}
                            <StyledExpirationDateInfo>
                                {t('agenda:project_expires_on', {
                                    date: formatLocaleDate(dayjs(project.expirationDate).toDate(), 'LL')
                                })}
                            </StyledExpirationDateInfo>
                        </StyledPatientAbsenceProjectInfo>
                    )
                ) : (
                    <StyledPatientAbsenceProjectInfo gap={1.5} fullWidth>
                        <span>{t('agenda:select_patient')}</span>
                    </StyledPatientAbsenceProjectInfo>
                )}
            </Flexbox>
        </DetailsField>
    )
}
